/**
 * The farm log for members: every entry, public and members-only, with
 * polls and selections answerable in place (components/FarmFeed.tsx). The
 * members-only entries are only readable here because /member/v1/journal
 * sits behind the bearer session token, which is the whole of what
 * "members only" means; nothing about the rendering is a boundary.
 */

import { Link } from 'wouter-preact';
import type { JSX } from 'preact';

import { FarmFeed } from '../components/FarmFeed.js';

export { humanDay, type LogSummary } from '../log-format.js';

export function LogView(): JSX.Element {
  return (
    <main class="view">
      <header>
        <span class="ff-eyebrow">The farm log</span>
        <h1>Notes from the farm</h1>
        <p class="muted">Everything we write, newest first. The entries marked “Members only” are just for you, and so are the polls and selections.</p>
      </header>

      <FarmFeed limit={50} />

      <p style="margin-top: 2rem;">
        <Link href="/account">← Your account</Link>
      </p>
    </main>
  );
}
